import { NavLink } from "react-router";
import { Shell, SupportLink, navLink } from "./Shell";

export function Layout() {
  return (
    <Shell nav={<>
      <NavLink to="/locations" className={navLink}>Locations</NavLink>
      <NavLink to="/rules" className={navLink}>Rules</NavLink>
      {/* Staff tab hidden for now; /staff still routes. */}
      <NavLink to="/activity" className={navLink}>Activity</NavLink>
      <NavLink to="/results" className={navLink}>Results</NavLink>
      <SupportLink />
    </>} />
  );
}
